var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHololens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "1.495 1.499 374.396 285.812",
    viewBox: "0 0 377.39 288.81",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "ugc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.02 161.12c-.71-.05-.79-33.11 2-56 2.5-20.5 24-24 24-24s2.89-3.54 7-4c113.77-12.61 170.38-20.69 297 0 4.94.81 9 5 9 5 22.5 4.5 27.02 13.05 29 19 6.5 19.5 4.7 60.91 4 61-144.5 18.5-189.5 11.5-372-1Z",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52 138.62c-.5-70.5 31.49-49.74 35-63 20.5-77.5 231.5-118.5 298 1 7.68 13.81 45.5-4.5 41 66-.27 4.27.53 10.18-1 20-2.47 15.87-11.94 76.58-65 108-10.57 6.26-53.5 21.5-80 15-20.76-5.09-23.14-65.69-40.5-65.5-16.64.18-24.13 53.45-41.5 64.5-5.5 3.5-14.69 6.75-77-12-51.5-15.5-65.1-94.74-68-113-1.36-8.57-.96-14.82-1-21Z",
    fill: "none",
    strokeWidth: 3,
    stroke: "#ff0000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02 161.12c88 9 283 18 373 2",
    fill: "none",
    strokeWidth: 3,
    stroke: "#ff0000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ff0000",
    strokeMiterlimit: 10,
    d: "M208.02 133.12c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ff0000",
    strokeMiterlimit: 10,
    d: "M78.02 127.62c0 11.874-13.208 21.5-29.5 21.5s-29.5-9.626-29.5-21.5 13.208-21.5 29.5-21.5 29.5 9.626 29.5 21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ff0000",
    strokeMiterlimit: 10,
    d: "M361.02 127.62c0 11.874-13.208 21.5-29.5 21.5s-29.5-9.626-29.5-21.5 13.208-21.5 29.5-21.5 29.5 9.626 29.5 21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.02 77.12c114-16 188-15 299 0",
    fill: "none",
    strokeWidth: 3,
    stroke: "#ff0000",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHololens);
export default __webpack_public_path__ + "static/media/hololens.5a03d94c70bd4fc5c5ca708edd4b6240.svg";
export { ForwardRef as ReactComponent };